<!-- 客户报表详情下级 -->
<template>
  
  <div class="comContent body-box">
    <div class="body-title">
      <div class="body-title-left">{{name}}~{{ shopName }}</div>
      <div class="body-title-right"><el-button size="small" @click="goBack">返回</el-button></div>
    </div>
    <div class="body-tools">
      <div class="body-tools-left">
        <el-form ref="formTool" :model="formTool" :inline="true">
          <el-form-item label="" prop="">
            <el-input v-model="formTool.orderCode" size="small" placeholder="请输入订单编号" clearable />
          </el-form-item>
          <el-form-item label="" prop="">
            <el-date-picker v-model="formTool.orderTime" size="small" type="daterange" value-format="yyyy-MM-dd" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="" prop="">
            <el-select v-model="formTool.operateId" size="small" placeholder="请选择运营部门" clearable>
              <el-option v-for="item in dptOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="phne">
            <MyButton type="primary" text="查询" @click="goSearch" />
            <el-button size="small" @click="formToolReset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="body-tools-right">
        <!-- <MyButton type="primary" text="返回" @click="goBack" /> -->
      </div>
    </div>
    <div class="body-table">
      <MyTable :table-data="tableData"
        max-height="calc(100% - 44px)"
        :index="false"
        :selection="false"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
        @sort-change="sortChange"
        @handleSelectionChange="currentChange">
        <template slot="tools" slot-scope="scope">
          <div style="display:flex">
            <el-link type="primary" :underline="false" size="small" @click="goLink(scope.row)">订单明细</el-link>
          </div>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>

import MyButton from '@/components/myButton';
import MyTable from '@/components/myTable';
import { getAllDepts } from '@/api/externalSalesRule';
import { queryGoodsSalesEcharts } from "@/api/statistics";
export default {
  name:'ReportCustomerDetailMore',
  components: { MyButton, MyTable },
  data() {
    return {
      id:'',
      name:'',
      shopId:'',
      shopName:'',
      formTool: {
        orderCode:'',
        orderTime:'',
        operateId:'',
      },
      dptOptions: [
        { value: '选项1', label: '黄金糕' },
        { value: '选项2', label: '双皮奶' },
        { value: '选项3', label: '蚵仔煎' },
        { value: '选项4', label: '龙须面' },
        { value: '选项5', label: '北京烤鸭' }
      ],
      tableData: [],
      tableOption: [
        { label: '订单创建时间', prop: 'order_time', width: '160px' },
        { label: '订单编号', prop: 'related_order_code', minWidth: '140px' },
        { label: '运营部门', prop: 'dept_name', minWidth: '140px' },
        { label: '运营负责人及联系方式', prop: 'dept_concat_name', minWidth: '140px' },
        { label: '订单金额(元)', prop: 'amount', minWidth: '90px' },
        { label: '操作', prop: 'tools', slot: true, width: '80px' }
      ],
      page: { total: 10, current: 1, size: 10 },
      sortStatus:'up',
      sortType:'1',// 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
    };
  },
  computed: {},
  watch: {},
  created() {
    let query = this.$route.query;
    // console.log('query',query)
    if(query.id && query.name && query.shopId && query.shopName ){
      this.id = query.id;
      this.name = query.name;
      this.shopId = query.shopId;
      this.shopName = query.shopName;
      this.getDepts();
      this.initData();
    }else{
      this.goBack();
    }
  },
  mounted() {

  },
  methods: {
    goLink(el){
      // let url = '/reportCustomer/reportCustomer-reportDetailMore'
      let url = `/business/businessManage-order-detail?id=${el.order_id}`; // related_order_code,order_id
      this.$router.push(url);
    },
    goSearch(){
      this.sortStatus = 'up';
      // this.sortType = '1';
      this.initData();
    },
    sortChange(el){
      const { column, prop, order } = el; // order释义：descending:降,ascending:升,为空时代表不选中
      console.log(column, prop, order)
      // 执行条件搜索操作
      // let propNames = {
      //   order_cnt: { label: '订单量', value: '1' },
      //   qty: { label: '商品数量', value: '2' },
      //   amount: { label: '采购额', value: '3' },
      //   avg_order_amount: { label: '客单价', value: '4' },
      //   shp_first_ord_time: { label: '首次下单时间', value: '5' },
      //   shp_last_ord_time: { label: '最后下单时间', value: '6' },
      //   last_visit_time: { label: '最后访问时间', value: '7' },
      // }
      // // 执行条件搜索操作
      // this.sortStatus = order == 'descending'?'down':'up';
      // // sortType:'1',// 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
      // this.sortType = (order && propNames[prop]) ? propNames[prop].value : '1';
      // this.initData();
    },
    getDepts(){
      // let shopId = "1608731543753244673";
      let obj = {
        type: 108,
        params:[this.shopId, this.shopId],
      }
      queryGoodsSalesEcharts(obj).then(list=>{
        // console.log(res);
        this.dptOptions = (list && list.length>0)?list.map(li=>{
          return {label:li.dept_name,value:li.id}
        }):[];
      })
    },
    formToolReset () {
      this.formTool = {
        orderCode:'',
        orderTime:'',
        operateId:'',
      }
      // this.$refs.formTool.resetFields()
      this.initData()
    },
    currentChange(){},
    initData(){
      this.page.current = 1;
      this.getList();
    },
    getList(){
      let obj = this.getParams(this.sortStatus);
      let totalObj = this.getParams('total');
      queryGoodsSalesEcharts(obj).then(list=>{
        this.tableData = list || [];
      })
      queryGoodsSalesEcharts(totalObj).then(list=>{
        // 获取总条数
        let total = 0;
        if(list && list.length>0){
          total = parseInt(list[0].cnt);
        }
        this.page.total = total;
      })
    },
    getParams(status = 'up'){
      const { current, size } = this.page;
      const { orderCode, orderTime, operateId } = this.formTool;

      let firstSTime = '';
      let firstETime = '';
      if(orderTime && orderTime.length>0){
        firstSTime = orderTime[0].replaceAll('-', '');
        firstETime = orderTime[1].replaceAll('-', '');
      }
      let types = {
        up: 95, down:96, total:97, // export:57
      }
      let type = types[status];
      let params = [
        this.id,// 客户ID"1606205771220635650"
        this.shopId,// 商户ID"1606205771220635650"
        orderCode || '',orderCode || '', // 订单编号
        firstSTime,firstSTime, // 首次下单时间(开始时间)
        firstETime,firstETime, // 首次下单时间(结束时间)
        '','', // 部门ID
      ]
      let paramsMore = [
        // this.sortType, // 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
        size, // 每页行数
        (current - 1)*size, // 第几行开始
      ]
      return { type, params: (status=='up' || status == 'down') ? [ ...params, ...paramsMore ] : params}
    },
    goBack () {
      // console.log('go back');
      // this.$router.push("/reportCustomer/reportCustomer-reportList");

      // this.$router.go(-1)：后退+刷新；
      // this.$router.go(0)：刷新；
      // this.$router.go(1) ：前进
      this.$router.back(); //:后退
      // this.$router.back(0) 刷新;
      // this.$router.back(1)：前进
    },
  },
  // beforeCreate() { },
  // beforeMount() { },
  // beforeUpdate() { },
  // updated() { },
  // beforeDestroy() { },
  // destroyed() { },
  // activated() { },
}
</script>
<style lang='scss' scoped>
.body{
  &-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    border-bottom: 1px solid #eee;
    &-left{
      width: calc(100% - 90px);
      line-height: 1;
      font-size: 26px;
      font-weight: 600;
      color: #000;
    }
    &-right{
      width: 90px;
      text-align: right;
    }
  }
  &-tools{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 16px;
    &-left{
      width: calc(100% - 90px);
    }
    &-right{
      width: 90px;
      text-align: right;
    }
    ::v-deep .el-form{
      &-item{
        margin-bottom: 6px !important;
      }
    }
  }
  &-table{
    height: calc(100% - 130px);
  }
}
</style>
